export default class BusinessUnitSelect {
    constructor () {
        this.businessUnitGroupField = document.getElementById('businessUnitGroup')
        this.businessUnitField = document.getElementById('businessUnit')
        this.businessUnitsByGroupJson = document.getElementById('businessUnitsByGroup');
        if (!this.businessUnitsByGroupJson || !this.businessUnitGroupField || !this.businessUnitField) {
            return;
        }

        this.businessUnitsByGroup = JSON.parse(this.businessUnitsByGroupJson.innerText)
        this.businessUnitGroupField.addEventListener('change', function (event) {
            // Clear field
            this.businessUnitField.setAttribute('value', null)
            this.businessUnitField.innerHTML = ''

            const selectedBusinessUnitGroup = event.target.value
            this.updateBusinessUnitField(selectedBusinessUnitGroup);
        }.bind(this))

        this.currentBusinessUnitGroup = document.getElementById('currentBusinessUnitGroup')
        this.currentBusinessUnit = document.getElementById('currentBusinessUnit')
        if (this.currentBusinessUnitGroup && this.currentBusinessUnit) {
            this.businessUnitGroupField.value = this.currentBusinessUnitGroup.innerText
            this.updateBusinessUnitField(this.currentBusinessUnitGroup.innerText, this.currentBusinessUnit.innerText)
        }
    }

    updateBusinessUnitField(selectedBusinessUnitGroup, preselectBusinessUnit = null) {
        const changeEvent = new Event('change');

        if (selectedBusinessUnitGroup) {
            this.businessUnitField.removeAttribute('disabled')
            const businessUnitsForSelectedGroup = this.businessUnitsByGroup[selectedBusinessUnitGroup]

            // Add empty option
            let option = document.createElement('option')
            this.businessUnitField.appendChild(option)

            Object.keys(businessUnitsForSelectedGroup).forEach((identifier) => {
                let label = businessUnitsForSelectedGroup[identifier]
                let option = document.createElement('option')
                option.setAttribute('value', identifier)
                option.innerText = label

                if (identifier === preselectBusinessUnit) {
                    option.setAttribute('selected', 'selected')
                }

                this.businessUnitField.appendChild(option)
            })
        } else {
            this.businessUnitField.setAttribute('disabled', 'disabled')
        }

        this.businessUnitField.dispatchEvent(changeEvent)
    }
}
